import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import Loading from "@irati/ui/src/Loading";
var ShowMore = function (_a) {
    var onNewPage = _a.onNewPage;
    var _b = useState(null), load = _b[0], setLoad = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(VisibilitySensor, { partialVisibility: true, onChange: function (isVisible) { return setLoad(onNewPage(isVisible)); } },
            React.createElement("div", { style: { height: 10 } })),
        React.createElement(Loading, { load: load })));
};
export default ShowMore;
